<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_statis_qiye'}">标杆企业数据统计</el-breadcrumb-item>
						  
						  <!-- <el-breadcrumb-item v-if="daqu == 1">大区A</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="daqu == 2">大区B</el-breadcrumb-item> -->
						  <!-- <el-breadcrumb-item v-if="tuwen_type == 43">知识产权工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="tuwen_type == 45">知识产权案例</el-breadcrumb-item> -->
						  
						</el-breadcrumb>
					</div>
					
					<div class="nrqy">
						
						<el-row class="tiaojian_elrow" style="margin-top: -10px;">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按地区：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_prov_type[0]" @click="clickDiqu(0, 0)">不限</el-tag>
									<el-dropdown size="small" placement="top-end" @command="selectProv">
										<span class="el-dropdown-link">
											{{prov_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限省份</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_prov" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
									<el-dropdown size="small" placement="top-end" @command="selectCity">
										<span class="el-dropdown-link">
											{{city_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限地市</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_city" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
							</el-col>
						</el-row>
						
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按领域：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_lingyu_type[0]" @click="clickLingyu(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_lingyu" :key="index" :type="list_lingyu_type[index+1]" @click="clickLingyu(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按年份：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_year_type[0]" @click="clickYear(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_year" :key="index" :type="list_year_type[index+1]" @click="clickYear(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						<el-row class="tiaojian_elrow" v-show="is_show_month">
							<el-col :span="2" :push="1">
								<div class="tiaojian_line_row_left" style="font-size: 13px;">
									按月份：
								</div>
							</el-col>
							<el-col :span="20" :push="1">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_month_type[0]" @click="clickMonth(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_month" :key="index" :type="list_month_type[index+1]" @click="clickMonth(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<!-- <el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按类型：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_fx_leixing_type[0]" @click="clickFxleixing(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_fx_leixing" :key="index" :type="list_fx_leixing_type[index+1]" @click="clickFxleixing(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row> -->
						
						<el-row class="tiaojian_elrow" style="border: 0px;">
							<el-col :span="21" :push="1">
								<div class="tiaojian_line_row_right">
									<el-input
										placeholder="请输入关键词搜索..."
										prefix-icon="el-icon-search"
										style="width: 40%;"
										v-model="keyword"
										:clearable="true"
										@clear="clearInput"
										>
									</el-input>
									<el-button type="primary" size="medium" @click="doSearch" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
									<span class="span_search_result">检索到{{total}}条数据（共涉及40项指标）；部分数据显示为0表示该指标未被公开披露或无法计算</span>
								</div>
							</el-col>
						</el-row>
						
					</div>
					
					<div class="neirong_line">
						<div class="neirong_line_left" style="width: 96%;">
							
							<el-empty description="没找到你想要的数据..." v-show="is_show_empty"></el-empty>
							
							<el-row>
								<div class="statis_line_out">
									<div class="statis_line_inner">
										<div class="statis_line_header" style="width: 300px; position:absolute; background: #fff">
											企业名称 <span style="color: #777; font-size: 12px;">(点击列标题可排序)</span>
										</div>
										<div style="margin-left: 300px;">
											<div class="statis_line_header" style="width: 140px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('zhucezj')">
													<i class="el-icon-arrow-down" v-if="sort_col=='zhucezj' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='zhucezj' && sort_sc=='asc'"></i>
													注册资金（万元）
												</span>
											</div>
											<div class="statis_line_header" style="width: 140px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('faxinggs')">
													<i class="el-icon-arrow-down" v-if="sort_col=='faxinggs' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='faxinggs' && sort_sc=='asc'"></i>
													发行股数（万股）
												</span>
											</div>
											<div class="statis_line_header" style="width: 140px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('mujizjze')">
													<i class="el-icon-arrow-down" v-if="sort_col=='mujizjze' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='mujizjze' && sort_sc=='asc'"></i>
													募集资金总额(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 140px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('buchongyyzj')">
													<i class="el-icon-arrow-down" v-if="sort_col=='buchongyyzj' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='buchongyyzj' && sort_sc=='asc'"></i>
													补充营运资金(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('zichanze3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='zichanze3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='zichanze3' && sort_sc=='asc'"></i>
													资产总额(万元)
												</span>
											</div>
											<!-- <div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yanfaxmzc')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yanfaxmzc' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yanfaxmzc' && sort_sc=='asc'"></i>
													研发支出（万元）
												</span>
											</div> -->
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('zichanfzl3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='zichanfzl3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='zichanfzl3' && sort_sc=='asc'"></i>
													资产负债率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yingyesr3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yingyesr3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yingyesr3' && sort_sc=='asc'"></i>
													营业收入(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('jinglir3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='jinglir3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='jinglir3' && sort_sc=='asc'"></i>
													净利润(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('meigusy3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='meigusy3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='meigusy3' && sort_sc=='asc'"></i>
													每股收益 (元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('maolil3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='maolil3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='maolil3' && sort_sc=='asc'"></i>
													毛利率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yanfafy3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yanfafy3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yanfafy3' && sort_sc=='asc'"></i>
													研发投入(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 140px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yafatrzb3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yafatrzb3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yafatrzb3' && sort_sc=='asc'"></i>
													研发投入占营收比
												</span>
											</div>
											<div class="statis_line_header" style="width: 140px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('hexincpsr3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='hexincpsr3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='hexincpsr3' && sort_sc=='asc'"></i>
													核心技术收入占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('jingzicze')">
													<i class="el-icon-arrow-down" v-if="sort_col=='jingzicze' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='jingzicze' && sort_sc=='asc'"></i>
													净资产(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('wuxingzc3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='wuxingzc3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='wuxingzc3' && sort_sc=='asc'"></i>
													无形资产(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('shangyu3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='shangyu3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='shangyu3' && sort_sc=='asc'"></i>
													商誉
												</span>
											</div>
											<!-- <div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yingfuzgxc3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yingfuzgxc3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yingfuzgxc3' && sort_sc=='asc'"></i>
													职工薪酬(万元)
												</span>
											</div> -->
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yingjiaosf3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yingjiaosf3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yingjiaosf3' && sort_sc=='asc'"></i>
													应交税费(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('zhengfubz3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='zhengfubz3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='zhengfubz3' && sort_sc=='asc'"></i>
													政府补助(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('xiaoshoufy3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='xiaoshoufy3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='xiaoshoufy3' && sort_sc=='asc'"></i>
													销售费用(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yanfafy3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yanfafy3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yanfafy3' && sort_sc=='asc'"></i>
													研发费用(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('caiwufy3')">
													<i class="el-icon-arrow-down" v-if="sort_col=='caiwufy3' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='caiwufy3' && sort_sc=='asc'"></i>
													财务费用(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yuangongzs')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yuangongzs' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yuangongzs' && sort_sc=='asc'"></i>
													公司人数
												</span>
											</div>
											
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('yanfaryb')">
													<i class="el-icon-arrow-down" v-if="sort_col=='yanfaryb' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='yanfaryb' && sort_sc=='asc'"></i>
													研发人员占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('guanliryb')">
													<i class="el-icon-arrow-down" v-if="sort_col=='guanliryb' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='guanliryb' && sort_sc=='asc'"></i>
													管理人员占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('xiaoshouryb')">
													<i class="el-icon-arrow-down" v-if="sort_col=='xiaoshouryb' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='xiaoshouryb' && sort_sc=='asc'"></i>
													销售人员占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('shengchanryb')">
													<i class="el-icon-arrow-down" v-if="sort_col=='shengchanryb' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='shengchanryb' && sort_sc=='asc'"></i>
													生产人员占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('dazhuanrs')">
													<i class="el-icon-arrow-down" v-if="sort_col=='dazhuanrs' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='dazhuanrs' && sort_sc=='asc'"></i>
													大专人数
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('benkers')">
													<i class="el-icon-arrow-down" v-if="sort_col=='benkers' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='benkers' && sort_sc=='asc'"></i>
													本科人数
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('shuoshijysrs')">
													<i class="el-icon-arrow-down" v-if="sort_col=='shuoshijysrs' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='shuoshijysrs' && sort_sc=='asc'"></i>
													硕士及以上人数
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('zhuyingywsrzb')">
													<i class="el-icon-arrow-down" v-if="sort_col=='zhuyingywsrzb' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='zhuyingywsrzb' && sort_sc=='asc'"></i>
													主营业务收入占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('wuxingzczb')">
													<i class="el-icon-arrow-down" v-if="sort_col=='wuxingzczb' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='wuxingzczb' && sort_sc=='asc'"></i>
													无形资产占比
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('jinglirl')">
													<i class="el-icon-arrow-down" v-if="sort_col=='jinglirl' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='jinglirl' && sort_sc=='asc'"></i>
													净利润率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('jingzicsyl')">
													<i class="el-icon-arrow-down" v-if="sort_col=='jingzicsyl' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='jingzicsyl' && sort_sc=='asc'"></i>
													净资产收益率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('jinsannxssrzzl')">
													<i class="el-icon-arrow-down" v-if="sort_col=='jinsannxssrzzl' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='jinsannxssrzzl' && sort_sc=='asc'"></i>
													销售收入增长率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('jinsannjzczzl')">
													<i class="el-icon-arrow-down" v-if="sort_col=='jinsannjzczzl' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='jinsannjzczzl' && sort_sc=='asc'"></i>
													净资产增长率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('xiaoshousrfhzzl')">
													<i class="el-icon-arrow-down" v-if="sort_col=='xiaoshousrfhzzl' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='xiaoshousrfhzzl' && sort_sc=='asc'"></i>
													销售复合增长率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('lirunzefhzzl')">
													<i class="el-icon-arrow-down" v-if="sort_col=='lirunzefhzzl' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='lirunzefhzzl' && sort_sc=='asc'"></i>
													利润复合增长率
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('renjunys')">
													<i class="el-icon-arrow-down" v-if="sort_col=='renjunys' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='renjunys' && sort_sc=='asc'"></i>
													人均营收(万元)
												</span>
											</div>
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('renjunsf')">
													<i class="el-icon-arrow-down" v-if="sort_col=='renjunsf' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='renjunsf' && sort_sc=='asc'"></i>
													人均税费(万元)
												</span>
											</div>
											<!-- <div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('zhigongnpjxc')">
													<i class="el-icon-arrow-down" v-if="sort_col=='zhigongnpjxc' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='zhigongnpjxc' && sort_sc=='asc'"></i>
													年平均薪酬(万元)
												</span>
											</div> -->
											<div class="statis_line_header" style="width: 120px; font-size: 13px">
												<span style="cursor: pointer;" @click="doSort('renjunjlr')">
													<i class="el-icon-arrow-down" v-if="sort_col=='renjunjlr' && sort_sc=='desc'"></i>
													<i class="el-icon-arrow-up" v-if="sort_col=='renjunjlr' && sort_sc=='asc'"></i>
													人均净利润(万元)
												</span>
											</div>
											
										</div>
										
									</div>
									<div class="statis_line_inner" v-for="(item, index) in list_record" :key="index">
										<div class="statis_line_content" @click="toDetailSigle(item.comId)" style="width: 300px; position:absolute; background: #fff; cursor: pointer;">
											{{item.comName}}
										</div>
										<div style="margin-left: 300px;">
											<div class="statis_line_content" style="width: 140px; font-size: 13px; color: #555;">
												<span>{{item.zhucezj}}</span>
											</div>
											<div class="statis_line_content" style="width: 140px; font-size: 13px; color: #555;">
												<span>{{item.faxinggs}}</span>
											</div>
											<div class="statis_line_content" style="width: 140px; font-size: 13px; color: #555;">
												<span>{{item.mujizjze}}</span>
											</div>
											<div class="statis_line_content" style="width: 140px; font-size: 13px; color: #555;">
												<span>{{item.buchongyyzj}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.zichanze3}}</span>
											</div>
											<!-- <div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yanfaxmzc}}</span>
											</div> -->
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.zichanfzl3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yingyesr3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.jinglir3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.meigusy3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.maolil3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yanfafy3}}</span>
											</div>
											<div class="statis_line_content" style="width: 140px; font-size: 13px; color: #555;">
												<span>{{item.yafatrzb3}}</span>
											</div>
											<div class="statis_line_content" style="width: 140px; font-size: 13px; color: #555;">
												<span>{{item.hexincpsr3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.jingzicze}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.wuxingzc3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.shangyu3}}</span>
											</div>
											<!-- <div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yingfuzgxc3}}</span>
											</div> -->
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yingjiaosf3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.zhengfubz3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.xiaoshoufy3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yanfafy3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.caiwufy3}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yuangongzs}}</span>
											</div>
											
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.yanfaryb}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.guanliryb}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.xiaoshouryb}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.shengchanryb}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.dazhuanrs}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.benkers}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.shuoshijysrs}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.zhuyingywsrzb}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.wuxingzczb}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.jinglirl}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.jingzicsyl}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.jinsannxssrzzl}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.jinsannjzczzl}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.xiaoshousrfhzzl}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.lirunzefhzzl}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.renjunys}}</span>
											</div>
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.renjunsf}}</span>
											</div>
											<!-- <div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.zhigongnpjxc}}</span>
											</div> -->
											<div class="statis_line_content" style="width: 120px; font-size: 13px; color: #555;">
												<span>{{item.renjunjlr}}</span>
											</div>
											
										</div>
									</div>
								</div>
							</el-row>
							
							<div class="neirong_line_split"></div>
							
							<div class="neirong_line_page">
								<el-pagination
								  background
								  layout="prev, pager, next, jumper"
								  :page-size="7"
								  :total="total"
								  @current-change="handlePage"
								  >
								</el-pagination>
							</div>
							
						</div>
						
						
						<!-- <div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div> -->
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				list_prov: [],
				list_city: [],
				list_prov_type: ['primary', ],
				
				list_lingyu: [],
				list_lingyu_type: ['primary', ],
				
				list_year: [],
				list_year_type: ['primary', ],
				
				is_show_month: false,
				list_month: [],
				list_month_type: ['primary', ],
				
				list_fx_leixing: [],
				list_fx_leixing_type: ['primary', ],
				
				is_show_empty: false,
				prov_text: '选择省份', // 用户选择的省份名
				city_text: '选择地市', // 用户选择的城市名
				prov_val: 0, // 用户选择的省份值
				city_val: 0, // 用户选择的城市值
				lingyu_val: 0, // 用户选择的领域
				year_val: 0, //用户选择的年份
				month_val: 0, // 用户选择的月份
				fx_leixing_val: 0, // 用户选择的风险关键词类型值
				keyword: '', // 搜索关键词
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				
				fullscreenLoading: false,
				
				list_wenda_kw: [],
				
				sort_col: 'com_id',
				sort_sc: 'asc',
				
				
				
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDictLingyu()
			this.loadDictYear()
			this.loadDictMonth()
			this.loadProv()
			// this.loadCity('37') // 点击省份后触发加载城市
			// this.loadDictFxleixing() // 加载搜索条件风险因素类型 问询答复暂时没有类型，该数据暂时不用
			
			// this.loadWendaKw() // 加载问询答复关键词
			
			this.doSearch(1) // 加载列表数据

			this.checkLogin() // 检查是否登录2025年12月初
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			// 跳转企业详情
			toDetailSigle(com_id) {
				let url = '/detail_company?id=' + com_id
				let route_data = this.$router.resolve({path: url})
				window.open(route_data.href, '_blank')
			},
			
			// 数据统计可能用不到该方法了，直接toUrl到标杆企业即可，最后看没用的话就删掉
			toDetail(com_id, daqu_id, mokuai_id) {
				console.log('com_id:' + com_id, 'daqu_id:' + daqu_id, 'mokuai_id:' + mokuai_id)
			},
			
			// 加载搜索数据，flag约定传值1或-1，flag为标记是否第1页，传1则第1页，传-1则不改变翻页值（使用已有第x页的值）
			doSearch(flag) {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				if (flag == 1) {
					this.pi = 1
				}
				let url = this.$common.apiUrl + 'pub_company_base/clientSearchStatisQiye'
				let client_data_json = {
					prov: this.prov_val,
					city: this.city_val,
					lingyu: this.lingyu_val,
					year: this.year_val,
					month: this.month_val,
					keyword: this.keyword,
					pi: this.pi,
					sortcol: this.sort_col,
					sortsc: this.sort_sc
				}
				let client_data = this.$qs.stringify(client_data_json)
				this.$axios.post(url, client_data).then((res)=>{
					console.log(res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false
					}
				})
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.doSearch(1)
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.doSearch(-1)
				document.documentElement.scrollTop = 0;
			},
			
			// 加载字典数据（行业领域）
			loadDictLingyu() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_hangyelingyu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_lingyu = res.data.data
					// 绑定样式数组
					this.list_lingyu.forEach((item, index) => {
						this.list_lingyu_type.push('info')
					})
				})
			},
			
			// 加载字典数据（年份）
			loadDictYear() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_year'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_year = res.data.data
					// 绑定样式数组
					this.list_year.forEach((item, index) => {
						this.list_year_type.push('info')
					})
				})
			},
			
			// 加载字典数据（月份）
			loadDictMonth() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_month'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_month = res.data.data
					// 绑定样式数组
					this.list_month.forEach((item, index) => {
						this.list_month_type.push('info')
					})
				})
			},
			
			// 加载省份
			loadProv() {
				let url = this.$common.apiUrl + 'pub_region/listProv'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_prov = res.data.data
				})
			},
			
			// 加载地市
			loadCity(provid) {
				let url = this.$common.apiUrl + 'pub_region/listCity/' + provid
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_city = res.data.data
				})
			},
			
			// 加载风险因素关键词类型字典（搜索条件）
			loadDictFxleixing() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_keyword_type'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					res.data.data.forEach((item, index) => {
						if (item.dictLabel.indexOf('风险因素关键词') > -1) {
							item.dictLabel = item.dictLabel.replace('数据统计-风险因素关键词-', '')
							this.list_fx_leixing.push(item)
						}
					})
					// 绑定样式数组
					this.list_fx_leixing.forEach((item, index) => {
						this.list_fx_leixing_type.push('info')
					})
				})
			},
			
			// 选择省份
			selectProv(command) {
				// console.log(command)
				if (command == 0) {
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.$set(this.list_prov_type, 0, 'primary')
				} else if (command > 0) {
					this.list_prov.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.prov_val = item.id
							this.prov_text = item.name
							this.loadCity(this.prov_val) // 加载下级城市
							this.$set(this.list_prov_type, 0, 'info')
							this.city_val = 0
							this.city_text = '选择城市'
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 选择城市
			selectCity(command) {
				if (command == 0) {
					this.city_val = 0
					this.city_text = '选择城市'
				} else if (command > 0) {
					this.list_city.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.city_val = item.id
							this.city_text = item.name
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 点击地区条件（这个略特殊，只有“不限”按钮触发）
			clickDiqu(index, id) {
				if (index == 0) {
					this.$set(this.list_prov_type, 0, 'primary')
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.city_val = 0
					this.city_text = '选择城市'
				}
				
				this.doSearch(1)
			},
			
			// 点击领域条件
			clickLingyu(index, id) {
				console.log(index, id)
				this.list_lingyu_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_lingyu_type, idx, 'primary')
					} else {
						this.$set(this.list_lingyu_type, idx, 'info')
					}
				})
				this.lingyu_val = id
				
				this.doSearch(1)
			},
			
			// 点击时间条件（年）
			clickYear(index, id) {
				// console.log(index, id)
				this.list_year_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_year_type, idx, 'primary')
					} else {
						this.$set(this.list_year_type, idx, 'info')
					}
				})
				this.year_val = id
				
				if (index == 0) {
					this.is_show_month = false
					this.month_val = 0
				} else {
					this.is_show_month = true
					this.clickMonth(0, 999999)
				}
				
				this.doSearch(1)
			},
			
			// 点击月份条件（月）
			clickMonth(index, id) {
				// console.log(index, id)
				this.list_month_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_month_type, idx, 'primary')
					} else {
						this.$set(this.list_month_type, idx, 'info')
					}
				})
				
				if (id == 999999) {
					this.month_val = 0
				} else {
					this.month_val = id
					this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
				}
			},
			
			// 点击风险因素关键词类型字典（搜索条件）  暂时去掉了
			clickFxleixing(index, id) {
				console.log(index, id)
				this.list_fx_leixing_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_fx_leixing_type, idx, 'primary')
					} else {
						this.$set(this.list_fx_leixing_type, idx, 'info')
					}
				})
				this.fx_leixing_val = id
				
				this.loadFengxianKw()
				
				this.doSearch(1)
			},
			
			// 加载问询答复关键词
			loadWendaKw() {
				let url = ''
				url = this.$common.apiUrl + 'pub_keyword_ipofile/listWendaKw'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_wenda_kw = res.data.data
				})
			},
			
			// 排序动作
			doSort (col) {
				this.sort_col = col
				if (this.sort_sc == 'asc') {
					this.sort_sc = 'desc'
				} else {
					this.sort_sc = 'asc'
				}
				this.doSearch(1);
			},

			// 判断用户是否登陆 2025年12月初，高莎莎发信息用户未登录，不显示详情，跳转至登录页
			checkLogin() {
				let cur_user = JSON.parse(localStorage.getItem('cur_user'));
				if (cur_user) {

				} else {
					this.$message.error('用户未登录，无法继续浏览，请登录会员后浏览和下载')
					setTimeout(() => {
						this.$router.push({path: '/login'})
					}, 2500)
					return;
				}
			},
			
			
			
			
		}
	}
</script>

<style scoped>
.el-dropdown-link {
	cursor: pointer;
	color: #409EFF;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.el-tag--small {
	margin: 0 10px;
}
.el-dropdown {
	margin: 0 10px;
}
</style>

<!-- 注册资金(万元)		zhucezj
发行股数 		faxinggs 
募集资金总额(万元)	mujizjze
补充营运资金(万元) 	buchongyyzj
资产总额(万元)		zichanze3
研发项目支出（万元）	yanfaxmzc
资产负债率%			zichanfzl3
营业收入(万元)		yingyesr3
净利润(万元)			jinglir3
每股收益 (元)		meigusy3
毛利率%				maolil3
研发投入(万元)		yanfafy3
研发投入占营业收入比%		yafatrzb3
核心技术收入占比		hexincpsr3
净资产		jingzicze
无形资产 		wuxingzc3
商誉			shangyu3
职工薪酬		yingfuzgxc3
应交税费		yingjiaosf3
政府补助		zhengfubz3
销售费用		xiaoshoufy3
研发费用		yanfafy3
财务费用		caiwufy3
公司人数		yuangongzs

研发人员占比%		yanfaryb
管理人员占比%		guanliryb
销售人员占比%		xiaoshouryb
生产人员占比%		shengchanryb
大专人数			dazhuanrs
本科人数			benkers
硕士及以上人数		shuoshijysrs



主营业务收入占比%		zhuyingywsrzb
无形资产占比%			wuxingzczb
净利润率%				jinglirl
净资产收益率%			jingzicsyl
近三年销售收入平均增长率%		jinsannxssrzzl
近三年净资产平均增长率%		jinsannjzczzl
销售收入复合增长率%			xiaoshousrfhzzl
利润总额复合增长率%			lirunzefhzzl
人均营收(万元） 			renjunys
人均税费（万元）			renjunsf
职工年平均薪酬（万元）		zhigongnpjxc
人均净利润（万元）			renjunjlr -->